import React, { Fragment } from 'react'
import { Button } from '@drifthq/tide-core'

import { isValid } from 'utils/password'
import PasswordInput from 'components/PasswordInput'

import './style.css'

export const PasswordStep = ({
  password,
  onPasswordChange,
  onContinueClick,
}) => {
  return (
    <Fragment>
      <h1>Set a Password</h1>
      <PasswordInput
        value={password}
        onChange={onPasswordChange}
      />
      <Button onClick={onContinueClick} disabled={!isValid({ password: password })}>
        Next
      </Button>
    </Fragment>
  )
}

export const AEPasswordStep = ({
  password,
  onPasswordChange,
  onContinueClick,
  isCalendarSeat
}) => {
  return (
    <Fragment>
      <h1>Activate your Drift Account</h1>
      <p>Just set your password!</p>
      <PasswordInput
        value={password}
        onChange={onPasswordChange}
      />
      <Button onClick={onContinueClick} disabled={!isValid({ password: password })} size="large" >
        Activate account
      </Button>
    </Fragment>
  )
}



// WEBPACK FOOTER //
// ./src/layouts/PasswordStep/component.js